<template>
    <div class="position-relative">
        <div v-if="state === 'error'" class="text-center">
            <h2>We were unable to load your profile information.</h2>
            <span>Our service may be temporarily unavailable. Please try again later.</span>
        </div>
        <div v-if="state === 'loading'" class="loader"></div>
        <div v-if="state === 'ready'" id="instances">
            <div class="card-deck mt-3">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Profile Information</h4>
                        <form @submit.prevent="update()">
                            <div class="form-group">
                                <label for="profileEmail">Email</label>
                                <input class="form-control" type="email" v-model="profile.email"
                                       placeholder="Empty" id="profileEmail">
                            </div>
                            <div class="form-group">
                                <label for="profileFirstName">First Name</label>
                                <input class="form-control" type="text"
                                       v-model="profile.first_name" placeholder="Empty" id="profileFirstName">
                            </div>
                            <div class="form-group">
                                <label for="profileLastName">Last Name</label>
                                <input type="text" class="form-control"
                                       v-model="profile.last_name" placeholder="Empty" id="profileLastName">
                            </div>
                            <div v-if="!$root.session.isSuperuser">
                                <h4 class="card-title">Email Notifications</h4>
                                <div class="form-group">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="weeklyDigest"
                                               v-model="profile.notifications_preferences.weekly_insights_digest">
                                        <label class="form-check-label" for="weeklyDigest">
                                            Weekly Status
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="segmentUpdate"
                                               v-model="profile.notifications_preferences.daily_records_update">
                                        <label class="form-check-label" for="segmentUpdate">
                                            Daily Segment Update Report
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <button type="submit" class="btn btn-primary position-relative"
                                    :disabled="updating || !(profile.email || '').length">
                                <span class="loader small"
                                     v-if="updating"></span>
                                Update Profile
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import settings from './index';

    export default Vue.extend({
        name: 'Profile',
        data: scope,
        methods: {
            update: update
        }
    });

    function update() {
        this.updating = true;

        return settings.update(this.profile).then((res) => {
            notie.alert('success', 'Updated profile settings.', 4);
            this.$store.commit('updateSession', res);
            this.updating = false;
        }).catch((err) => {
            this.updating = false;

            notie.alert(
                'error',
                'We were unable to update this profile. Please try again later.',
                6
            );

            throw err;
        });
    }

    function scope() {
        return {
            profile: Object.assign({}, this.$store.state.session),
            invitee: {
                first_name: "",
                last_name: "",
                email: ""
            },
            state: 'ready',
            updating: false,
            inviting: false
        };
    }

    function Profile(opts) {
        Object.assign(this, opts);
    }
</script>
